import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { exportaExcelConFotoOpcional } from "../../../excelConFotos";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { func } from "prop-types";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

function ListadoInventarios() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS = `${process.env.REACT_APP_URL_INVENTARIOS}`;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_ARTICULOS_PROPORCION = process.env.REACT_APP_URL_ARTICULOS_PROPORCION;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;

  const [lineas, setLineas] = useState([]);
  const [selectedLineaFiltro, setSelectedLineaFiltro] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");
  const [familias, setFamilias] = useState([]);
  const [selectedFamiliaFiltro, setSelectedFamiliaFiltro] = useState("");
  const [colecciones, setColecciones] = useState([]);
  const [selectedColeccion, setSelectedColeccion] = useState("");
  const [selectedAno, setSelectedAno] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  
  const [articulos, setArticulos] = useState([]);
  // Filtro de modelo multiple: lista de ids; vacia = todos
  const [selectedArticulos, setSelectedArticulos] = useState([]);
  const pasaArticulo = (id) => selectedArticulos.length === 0 || selectedArticulos.includes(String(id));

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("");

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const [idEditArticulo, setIdEditArticulo] = useState("");
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;
  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);

  const [desgloceRows, setDesgloceRows] = useState([]);
  const [desgloceCodigo, setDesgloceCodigo] = useState("");
  const [desgloceNombre, setDesgloceNombre] = useState("");
  const [desgloceArea, setDesgloceArea] = useState("");
  const [modalTablaColores, setModalTablaColores] = useState(false);
  const toggleTablaColores = () => setModalTablaColores(!modalTablaColores);
  const [arrayColores, setArrayColores] = useState([]);

  const [totalTotal, setTotalTotal] = useState(0);
  const [totalTotalCajas, setTotalTotalCajas] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  // Totales del pie: sobre TODOS los renglones filtrados, no solo la pagina visible
  const [totales, setTotales] = useState({ total: 0 });
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 100;

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);

  useEffect(() => {
    axios
      .get(`${URL_INVENTARIOS}Acumulado`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInventarios = response.data;
        // Array para pagination
        let arrayTabla = allInventarios
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            // if(a.cantidad >0){
            // if(
            //   (user.areas == AREAS_GENERAL)
            //   ){
            return {
              _id: a._id,
              activo: a.activo,
              cantidad: a.cantidad,
              color: a.color || "",
              talla: a.talla || "",
              idColor: a.idColor || "",
              variantes: a.variantes || [],
              codigo: a.codigo,
              nombre: a.nombre,
              idArticulo: a.idArticulo,
              costoUSD: a.costoUSD,
              costoMX: a.costoMX,
              venta: a.venta,
              observaciones: a.observaciones,
              idCompras: a.idCompras,
              piezasPorCaja: a.piezasPorCaja,
              linea: a.linea,
              idLinea: a.idLinea,
              marca: a.marca,
              idMarca: a.idMarca,
              familia: a.familia,
              idFamilia: a.idFamilia,
              coleccion: a.coleccion,
              idColeccion: a.idColeccion,
              proveedor: a.proveedor,
              idProveedor: a.idProveedor,
              cajas: (a.cantidad / a.piezasPorCaja).toFixed(2),
              area: a.area,
              idArea: a.idArea,
              urlFoto: a.urlFoto,
              ano: a.ano
            }
          // } else if(user.areas == a.idArea){
          //  return {
          //   _id: a._id,
          //   activo: a.activo,
          //   cantidad: a.cantidad,
          //   codigo: a.codigo,
          //   nombre: a.nombre,
          //   idArticulo: a.idArticulo,
          //   costoUSD: a.costoUSD,
          //   costoMX: a.costoMX,
          //   venta: a.venta,
          //   observaciones: a.observaciones,
          //   idCompras: a.idCompras,
          //   piezasPorCaja: a.piezasPorCaja,
          //   linea: a.linea,
          //   idLinea: a.idLinea,
          //   marca: a.marca,
          //   idMarca: a.idMarca,
          //   familia: a.familia,
          //   idFamilia: a.idFamilia,
          //   coleccion: a.coleccion,
          //   idColeccion: a.idColeccion,
          //   proveedor: a.proveedor,
          //   idProveedor: a.idProveedor,
          //   cajas: (a.cantidad / a.piezasPorCaja).toFixed(2),
          //   area: a.area,
          //   idArea: a.idArea,
          //   urlFoto: a.urlFoto,
          //   ano: a.ano
          //  }
          // }
        // }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);

      
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allLineas = response.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allMarcas = response.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_FAMILIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allFamilias = response.data;
        setFamilias(allFamilias);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColecciones = response.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);



  function PDFTabla() {
    let total_general = 0;
    let total_cajas = 0;
    let agrupado = comments.reduce(function (groups, item) {
      const val = item["idArticulo"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        cantidad: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val]._id = item._id;
      groups[val].activo = item.activo;
      groups[val].nombre = item.nombre;
      groups[val].codigo = item.codigo;
      groups[val].idArticulo = item.idArticulo;
      groups[val].costoUSD = item.costoUSD;
      groups[val].costoMX = item.costoMX;
      groups[val].venta = item.venta;
      groups[val].observaciones = item.observaciones;
      groups[val].idCompras = item.idCompras;
      groups[val].piezasPorCaja = item.piezasPorCaja;
      groups[val].linea = item.linea;
      groups[val].idLinea = item.idLinea;
      groups[val].marca = item.marca;
      groups[val].idMarca = item.idMarca;
      groups[val].familia = item.familia;
      groups[val].idFamilia = item.idFamilia;
      groups[val].coleccion = item.coleccion;
      groups[val].idColeccion = item.idColeccion;
      groups[val].proveedor = item.proveedor;
      groups[val].idProveedor = item.idProveedor;
      groups[val].area = item.area;
      groups[val].idArea = item.idArea;
      groups[val].cajas = item.cajas;
      groups[val].urlFoto = item.urlFoto;
      groups[val].ano = item.ano;
      return groups;
    },[])

    let computedComments = Object.values(agrupado);

    const data = computedComments
    .filter(
      (comment) =>
        String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.area ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.cajas ?? "").toString().includes(search)||
        String(comment.cantidad ?? "").toString().includes(search)||
        String(comment.piezasPorCaja ?? "").toString().includes(search)
    )
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        if (
          pasaArticulo(a.idArticulo) &&
          (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
          (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
          (selectedAno == 0 || selectedAno == a.ano) &&
          (selectedArea == 0 || selectedArea == a.idArea) &&
          (activo == 0 || activo == a.is_active)
        ) {
          total_general = parseFloat(total_general) + parseFloat(a.cantidad)
          total_cajas = parseFloat(total_cajas) + parseFloat(a.cajas)

          let foto = a.urlFoto === "No"
          ? process.env.PUBLIC_URL + "sinImagen.png"
          : a.urlFoto;

          return [
            foto,
            a.codigo,
            a.nombre,
            a.linea,
            a.marca,
            a.familia,
            a.coleccion,
            a.ano,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.venta),
          ];
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 30, 30);
    doc.text(`Listado Inventarios`, 20, 40);
    doc.setFontSize(8)
    doc.autoTable({
      head: [
        [
          "",
          "Codigo",
          "Nombre",
          "Linea",
          "Marca",
          "Departamento",
          "Coleccion",
          "Año",
          "Cantidad",
          "Venta",

        ],
      ],
      body: dataPDFLimpia,
      columnStyles: [
        { fontSize: .000001, textColor: [255, 255, 255], cellWidth: 20 },
      ],
 headStyles: {
            fillColor: ["#f28029"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#f28029"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(total_general),
        ],
      ],
      showFoot: "lastPage",
      styles: {
        minCellHeight: 20, // Ajusta la altura mínima de las filas
        cellPadding: 5,    // Ajusta el padding de las celdas para dar más espacio
        fontSize: 8
      },
      didDrawCell: function (data) {
        if (data.column.index === 0 && data.cell.section === 'body') {
          var td = data.cell.raw;
          var img = td;
          var textPos = data.cell;
          doc.addImage(img, textPos.x, textPos.y, 20, 20);
        }}
    });
    doc.save(`Inventarios.pdf`);
  }

  // El listado viene agrupado por articulo y almacen; para los reportes por
  // talla y color se abre cada renglon en sus variantes.
  function porVariante(a) {
    const vs = (a.variantes || []).length
      ? a.variantes
      : [{ idColor: a.idColor, color: a.color, codigoColor: "", idTalla: "", talla: a.talla, cantidad: a.cantidad }];
    return vs.map((v) => ({
      ...a,
      idColor: v.idColor || "",
      // el codigo del color va en su propia columna del Excel
      codigoColor: v.codigoColor && v.codigoColor !== "NA" ? v.codigoColor : "",
      color: v.color || "",
      talla: v.talla || "",
      cantidad: v.cantidad,
    }));
  }

  // Excel por talla y color: un renglon por articulo + color + talla + almacen,
  // con los mismos filtros que la tabla (comments trae un renglon por variante).
  // Excel GENERAL por talla y color: todo el inventario, sin filtros ni busqueda
  function excelGeneralTallaColor() {
    const filas = comments
      .flatMap(porVariante)
      .sort((x, y) => (x.codigo + x.color + x.talla > y.codigo + y.color + y.talla ? 1 : -1))
      .map((a) => ({
        _idArticulo: a.idArticulo, _idColor: a.idColor,
        Codigo: a.codigo, Nombre: a.nombre, Color: a.color, Talla: a.talla,
        Linea: a.linea, Marca: a.marca, Departamento: a.familia, Coleccion: a.coleccion,
        Almacen: a.area, Cantidad: a.cantidad,
      }));
    const cols = ["Codigo", "Nombre", "Color", "Talla", "Linea", "Marca", "Departamento", "Coleccion", "Almacen", "Cantidad"];
    exportaExcelConFotoOpcional({ filas, columnas: cols, nombreArchivo: "InventarioGeneralPorTallaColor", hoja: "General" });
  }

  function excelPorTallaColor() {
    const filas = comments
      .filter(
        (comment) =>
          String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.area ?? "").toLowerCase().includes(search.toLowerCase())
      )
      .filter((a) =>
        pasaArticulo(a.idArticulo) &&
        (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
        (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
        (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
        (selectedAno == 0 || selectedAno == a.ano) &&
        (selectedArea == 0 || selectedArea == a.idArea) &&
        (activo == 0 || activo == a.is_active)
      )
      .flatMap(porVariante)
      .sort((x, y) => (x.codigo + x.color + x.talla > y.codigo + y.color + y.talla ? 1 : -1))
      .map((a) => ({
        _idArticulo: a.idArticulo, _idColor: a.idColor,
        Codigo: a.codigo, Nombre: a.nombre, Color: a.color, Talla: a.talla,
        Linea: a.linea, Marca: a.marca, Departamento: a.familia, Coleccion: a.coleccion,
        Almacen: a.area, Cantidad: a.cantidad,
      }));
    const cols = ["Codigo", "Nombre", "Color", "Talla", "Linea", "Marca", "Departamento", "Coleccion", "Almacen", "Cantidad"];
    exportaExcelConFotoOpcional({ filas, columnas: cols, nombreArchivo: "InventarioPorTallaColor", hoja: "PorTallaColor" });
  }

  function excel() {
    let total_general = 0;
    let total_cajas = 0;
    let agrupado = comments.reduce(function (groups, item) {
      const val = item["idArticulo"] + item["idArea"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        cantidad: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val]._id = item._id;
      groups[val].activo = item.activo;
      groups[val].nombre = item.nombre;
      groups[val].codigo = item.codigo;
      groups[val].idArticulo = item.idArticulo;
      groups[val].costoUSD = item.costoUSD;
      groups[val].costoMX = item.costoMX;
      groups[val].venta = item.venta;
      groups[val].observaciones = item.observaciones;
      groups[val].idCompras = item.idCompras;
      groups[val].piezasPorCaja = item.piezasPorCaja;
      groups[val].linea = item.linea;
      groups[val].idLinea = item.idLinea;
      groups[val].marca = item.marca;
      groups[val].idMarca = item.idMarca;
      groups[val].familia = item.familia;
      groups[val].idFamilia = item.idFamilia;
      groups[val].coleccion = item.coleccion;
      groups[val].idColeccion = item.idColeccion;
      groups[val].proveedor = item.proveedor;
      groups[val].idProveedor = item.idProveedor;
      groups[val].area = item.area;
      groups[val].idArea = item.idArea;
      groups[val].cajas = item.cajas;
      groups[val].ano = item.ano;
      return groups;
    },[])

    let computedComments = Object.values(agrupado);

    const data = computedComments
    .filter(
      (comment) =>
        String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.area ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.cajas ?? "").toString().includes(search)||
        String(comment.cantidad ?? "").toString().includes(search)||
        String(comment.piezasPorCaja ?? "").toString().includes(search)
    )
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        if (
          pasaArticulo(a.idArticulo) &&
          (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
          (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
          (selectedAno == 0 || selectedAno == a.ano) &&
          (selectedArea == 0 || selectedArea == a.idArea) &&
          (activo == 0 || activo == a.is_active)
        ) {
          total_general = parseFloat(total_general) + parseFloat(a.cantidad)
          total_cajas = parseFloat(total_cajas) + parseFloat(a.cajas)
        return {
          _idArticulo: a.idArticulo,
          Codigo: a.codigo,
          Nombre: a.nombre,
          Linea: a.linea,
          Marca: a.marca,
          Departamento: a.familia,
          Coleccion: a.coleccion,
          Ano: a.ano,
          Cantidad: a.cantidad,
          Venta: a.venta,
          Almacen: a.area
        };
      }
    });
    const dataExportExcel = Object.values(data);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    const cols = ["Codigo", "Nombre", "Linea", "Marca", "Departamento", "Coleccion", "Ano", "Cantidad", "Venta", "Almacen"];
    exportaExcelConFotoOpcional({ filas: dataExcelLimpia, columnas: cols, nombreArchivo: "ListadoInventarios", hoja: "ListadoInventarios" });

  }

// Convertir Blob a base64
function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1];
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

async function excelConImagenes() {
  const agrupado = comments.reduce((groups, item) => {
    const key = item["idArticulo"] + item["idArea"];
    groups[key] = groups[key] || { ...item, cantidad: 0 };
    groups[key].cantidad += item.cantidad;
    return groups;
  }, {});

  const filtrados = Object.values(agrupado).filter((a) => {
    return (
      pasaArticulo(a.idArticulo) &&
      (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
      (selectedMarca == 0 || selectedMarca == a.idMarca) &&
      (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
      (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
      (selectedAno == 0 || selectedAno == a.ano) &&
      (selectedArea == 0 || selectedArea == a.idArea) &&
      (activo == 0 || activo == a.is_active)
    );
  });

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("ListadoInventarios");

  // Encabezados
  const headers = [
    "Foto", "Código", "Nombre", "Línea", "Marca", "Departamento", "Colección", "Año",
    "Cantidad", "Venta", "Almacén"
  ];
  sheet.addRow(headers);
  sheet.getRow(1).font = { bold: true };

  sheet.columns = [
    { width: 15 }, { width: 15 }, { width: 30 }, { width: 15 }, { width: 15 },
    { width: 15 }, { width: 15 }, { width: 10 },
    { width: 10 }, { width: 10 }, { width: 10 }, { width: 15 },
  ];

  for (let i = 0; i < filtrados.length; i++) {
    const item = filtrados[i];
    const rowIdx = i + 2;

    sheet.addRow([
      "", // imagen va aquí
      item.codigo,
      item.nombre,
      item.linea,
      item.marca,
      item.familia,
      item.coleccion,
      item.ano,
      item.cantidad,
      item.venta,
      item.area,
    ]);

    // Altura para que quepa la imagen
    sheet.getRow(rowIdx).height = 40;

    // 1) Imagen por defecto
    let imageUrl = process.env.PUBLIC_URL + "/sinImagen.png";

    // 2) Intentar jalar imagen real del artículo
    try {
      const res = await fetch(
        `${process.env.REACT_APP_URL_GETMEDIA}/${item.idArticulo}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_token")}`,
          },
        }
      );

      if (res.ok) {
        const data = await res.json();
        if (data && data.secure_url) {
          imageUrl = data.secure_url; // sustituimos la default
        } else {
          console.warn(`No se encontró secure_url para ${item.codigo}, usando sinImagen.png`);
        }
      } else {
        console.warn(`Respuesta no OK (${res.status}) para ${item.codigo}, usando sinImagen.png`);
      }
    } catch (err) {
      console.warn(`Error obteniendo imagen para ${item.codigo}, usando sinImagen.png`, err);
    }

    // 3) Insertar la imagen (real o default)
    try {
      const imgRes = await fetch(imageUrl);
      if (!imgRes.ok) {
        console.warn(`No se pudo descargar la imagen de ${imageUrl} para ${item.codigo}`);
        continue; // aquí sí ya no hay nada que hacer para la imagen, pero la fila ya está
      }

      const blob = await imgRes.blob();

      const extension = String(blob.type ?? "").includes("jpeg")
        ? "jpeg"
        : String(blob.type ?? "").includes("png")
        ? "png"
        : String(blob.type ?? "").includes("gif")
        ? "gif"
        : null;

      if (!extension) {
        console.warn(`Formato no compatible para ${item.codigo}: ${blob.type}`);
        continue;
      }

      const base64 = await blobToBase64(blob); // asegúrate que esta función ya la tienes

      const imageId = workbook.addImage({
        base64,
        extension,
      });

      sheet.addImage(imageId, {
        tl: { col: 0, row: rowIdx - 1 }, // columna 0, fila rowIdx
        ext: { width: 60, height: 60 },
      });
    } catch (e) {
      console.warn(`Error al insertar imagen para ${item.codigo}`, e);
    }
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "ListadoInventariosConFotos.xlsx");
}

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // reader.result viene como "data:image/png;base64,AAAA..."
      const result = reader.result;
      const base64 = typeof result === "string"
        ? result.split(",")[1] // nos quedamos solo con la parte base64
        : "";
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

  function enviaMail() {
    let total_general = 0;
    let total_cajas = 0;
    let agrupado = comments.reduce(function (groups, item) {
      const val = item["idArticulo"] + item["idArea"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        cantidad: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val]._id = item._id;
      groups[val].activo = item.activo;
      groups[val].nombre = item.nombre;
      groups[val].codigo = item.codigo;
      groups[val].idArticulo = item.idArticulo;
      groups[val].costoUSD = item.costoUSD;
      groups[val].costoMX = item.costoMX;
      groups[val].venta = item.venta;
      groups[val].observaciones = item.observaciones;
      groups[val].idCompras = item.idCompras;
      groups[val].piezasPorCaja = item.piezasPorCaja;
      groups[val].linea = item.linea;
      groups[val].idLinea = item.idLinea;
      groups[val].marca = item.marca;
      groups[val].idMarca = item.idMarca;
      groups[val].familia = item.familia;
      groups[val].idFamilia = item.idFamilia;
      groups[val].coleccion = item.coleccion;
      groups[val].idColeccion = item.idColeccion;
      groups[val].proveedor = item.proveedor;
      groups[val].idProveedor = item.idProveedor;
      groups[val].area = item.area;
      groups[val].idArea = item.idArea;
      groups[val].cajas = item.cajas;
      groups[val].ano = item.ano;
      return groups;
    },[])

    let computedComments = Object.values(agrupado);

    const data = computedComments
    .filter(
      (comment) =>
        String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.area ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.cajas ?? "").toString().includes(search)||
        String(comment.cantidad ?? "").toString().includes(search)||
        String(comment.piezasPorCaja ?? "").toString().includes(search)
    )
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        if (
          pasaArticulo(a.idArticulo) &&
          (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
          (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
          (selectedAno == 0 || selectedAno == a.ano) &&
          (selectedArea == 0 || selectedArea == a.idArea) &&
          (activo == 0 || activo == a.is_active)
        ) {
          total_general = parseFloat(total_general) + parseFloat(a.cantidad)
          total_cajas = parseFloat(total_cajas) + parseFloat(a.cajas)
          return [
            a.codigo,
            a.nombre,
            a.linea,
            a.marca,
            a.familia,
            a.coleccion,
            a.ano,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            a.area
          ];
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 30, 30);
    doc.text(`Listado Inventarios`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Linea",
          "Marca",
          "Departamento",
          "Coleccion",
          "Ano",
          "Cantidad",
          "Almacen",

        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#f28029"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#f28029"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(total_general),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Inventarios",
          email: mailTo,
          fileName: "ListadoInventarios.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Inventarios.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

 

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Linea", field: "linea", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    { name: "Departamento", field: "familia", sortable: true },
    { name: "Coleccion", field: "coleccion", sortable: true },
    { name: "Ano", field: "ano", sortable: true },
    { name: "Venta", field: "venta", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Ficha Tecnica", field: "foto", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.area ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.cajas ?? "").toString().includes(search)||
          String(comment.cantidad ?? "").toString().includes(search)||
          String(comment.venta ?? "").toString().includes(search)||
          String(comment.piezasPorCaja ?? "").toString().includes(search)
      );
    }

    if (selectedLineaFiltro) {
      computedComments = computedComments.filter((e) =>
        String(e.idLinea ?? "").includes(selectedLineaFiltro)
      );
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        String(e.activo ?? "").includes(activo)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        String(e.idMarca ?? "").includes(selectedMarca)
      );
    }
    if (selectedArticulos.length) {
      computedComments = computedComments.filter((e) => pasaArticulo(e.idArticulo));
    }
    if (selectedFamiliaFiltro) {
      computedComments = computedComments.filter((e) =>
        String(e.idFamilia ?? "").includes(selectedFamiliaFiltro)
      );
    }
    if (selectedColeccion) {
      computedComments = computedComments.filter((e) =>
        String(e.idColeccion ?? "").includes(selectedColeccion)
      );
    }
    if (selectedAno) {
      computedComments = computedComments.filter((e) =>
        String(e.ano ?? "").includes(selectedAno)
      );
    }
    if (selectedArea) {
      computedComments = computedComments.filter((e) =>
        String(e.idArea ?? "").includes(selectedArea)
      );
    }


        let can = computedComments.map((c) => parseFloat(c.cantidad));
        let TCan = can.reduce((t, cantidad, index) => t + cantidad, 0);
        setTotalTotal(TCan);

        let caj = computedComments.map((c) => parseFloat(c.cajas));
        let Tcaj = caj.reduce((t, cajas, index) => t + cajas, 0);
        setTotalTotalCajas(Tcaj);

    setTotalItems(computedComments.length);
    setTotales(computedComments.reduce((t, a) => ({
      total: t.total + (Number(parseFloat(a.cantidad)) || 0),
    }), { total: 0 }));

    //Sorting comments
    if (sorting.field && sorting.field != "cantidad"  && sorting.field != "piezasPorCaja" && sorting.field != "cajas" && sorting.field != "venta") {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (sorting.field && sorting.order === "asc" && (sorting.field == "cantidad" || sorting.field == "piezasPorCaja" || sorting.field == "cajas" || sorting.field != "venta")) {
      computedComments = computedComments.sort(
        (a, b) => parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (sorting.field && sorting.order === "desc" && (sorting.field == "cantidad" || sorting.field == "piezasPorCaja" || sorting.field == "cajas" || sorting.field != "venta")) {
      computedComments = computedComments.sort(
        (a, b) => parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedArticulos,
    activo,
    selectedLineaFiltro,
    selectedMarca, 
    selectedFamiliaFiltro, 
    selectedColeccion,
    selectedAno,
    selectedArea,
  ]);


  function limpiarSearch(){
    setSearch("")
    setSelectedArticulos([])
    setSelectedLineaFiltro("")
    setSelectedMarca("")
    setSelectedFamiliaFiltro("")
    setSelectedColeccion("")
    setSelectedAno("")
    setSelectedArea("")
  }

  
  function jalaFoto(
    idEdit
  ) {
    setPhoto("")
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
      })
      .catch((err) => console.log(err));


    setIdEditArticulo(idEdit);
    toggleFoto();
  }

  function verDesgloce(idArticulo, idArea, codigo, nombre, area) {
    setDesgloceRows([]);
    setDesgloceCodigo(codigo);
    setDesgloceNombre(nombre);
    setDesgloceArea(area);
    axios
      .get(`${URL_INVENTARIOS}ArticuloAreaDetalle/${idArticulo}/${idArea}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const filas = res.data
          .map((a) => ({
            color: a.colores?.[0]?.name || "Sin color",
            talla: a.tallas?.[0]?.name || "Sin talla",
            cantidad: Number(a.cantidad || 0),
          }))
          .filter((a) => a.cantidad !== 0);
        setDesgloceRows(filas);
        toggleTablaColores();
      })
      .catch((err) => console.log(err));
  }


  const total = totales.total;
  let total_cajas = 0;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.inventarios ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {/* <Button
                size="sm"
                href="/MenuInventarios"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button> */}
              
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excelPorTallaColor}
                  title="Un renglon por color y talla"
                >
                  Excel talla/color <i class="far fa-file-excel"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="success"
                  onClick={excelGeneralTallaColor}
                  title="Todo el inventario por color y talla, sin filtros"
                >
                  Excel general <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Inventarios</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
         
          <h3 align="center">Inventario General</h3>
          <div className="row">
            <div className="col-md-10">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div> <div className="col-md-1 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
             <div className="col-md-1 flex-row-reverse">
            <Button
                  size="sm"
                  className="btn"
                  color="info"
                  onClick={limpiarSearch}
                >
                  Limpiar
                </Button>
                </div>
           
          </div>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: "0px" }} colSpan={2}>
                <Autocomplete
                  multiple
                  size="small"
                  disableCloseOnSelect
                  options={articulos.slice().sort((a, b) => (a.codigo > b.codigo ? 1 : -1))}
                  getOptionLabel={(o) => `${o.codigo || ""} ${o.nombre || ""}`.trim()}
                  getOptionSelected={(o, v) => String(o._id) === String(v._id)}
                  value={articulos.filter((a) => selectedArticulos.includes(String(a._id)))}
                  onChange={(e, vals) => {
                    setSelectedArticulos(vals.map((v) => String(v._id)));
                    setCurrentPage(1);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" placeholder={selectedArticulos.length ? "" : "Todos los modelos"} />
                  )}
                  style={{ minWidth: 260 }}
                />
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedLineaFiltro}
                  onChange={(e) => {
                    setSelectedLineaFiltro(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a > b ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>

              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedFamiliaFiltro}
                  onChange={(e) => {
                    setSelectedFamiliaFiltro(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {familias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedColeccion}
                  onChange={(e) => {
                    setSelectedColeccion(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {colecciones
                    .sort((a, b) => (a > b ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>

              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedAno}
                  onChange={(e) => {
                    setSelectedAno(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {years.map((a) => {
                    return <option value={a}>{a}</option>;
                  })}
                </Input>
              </td>

              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArea}
                  onChange={(e) => {
                    setSelectedArea(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                        })}
                </Input>
              </td>
              <td></td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                total_cajas = total_cajas + parseFloat(a.cajas);
                {
                  return (
                    <tr>
                      <td>{a.codigo}</td>
                      <td>{a.nombre}</td>
                      <td>{a.linea}</td>
                      <td>{a.marca}</td>
                      <td>{a.familia}</td>
                      <td>{a.coleccion}</td>
                      <td>{a.ano}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.venta)}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.cantidad)}
                      </td>
                      <td>{a.area}</td>
                      <td>
                        <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                verDesgloce(
                                  a.idArticulo,
                                  a.idArea,
                                  a.codigo,
                                  a.nombre,
                                  a.area
                                )
                              }
                            >
                              <i class="fas fa-palette"></i>
                            </Button>
                      <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaFoto(
                                  a.idArticulo
                                )
                              }
                            >
                              <i class="fas fa-camera"></i>
                            </Button>

                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(total)}
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL GENERAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalTotal)}
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
  <Modal size="sm" isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>
            Ficha Tecnica
          </h4>
        </ModalHeader>
        <ModalBody>
        <Row>
            {photo ? (
              <h6 style={{ textAlign: "center" }}>
                <img
                  // loading="lazy"
                  src={`${process.env.REACT_APP_URL_FOTO_CLOUDINARY}/image/upload/v${photo}/cavannaImportacionArticulos/${idEditArticulo}.jpg`}
                  alt=""
                />
              </h6>
            ) : <h4>No se ha subido una Ficha Tecnica....</h4>}
          </Row>
        </ModalBody>
      </Modal>
        <Modal size="xl" isOpen={modalTablaColores} toggle={toggleTablaColores}>
          <ModalHeader toggle={toggleTablaColores}>
            <h4>Desglose por Color y Talla</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={4}><Label>Codigo: {desgloceCodigo}</Label></Col>
              <Col md={5}><Label>Nombre: {desgloceNombre}</Label></Col>
              <Col md={3}><Label>Almacen: {desgloceArea}</Label></Col>
            </Row>
            <br />
            {desgloceRows.length === 0 ? (
              <h6>Sin existencia para este articulo en este almacen.</h6>
            ) : (
              (() => {
                const colores = [...new Set(desgloceRows.map((r) => r.color))].sort((a, b) => a.localeCompare(b));
                const tallas = [...new Set(desgloceRows.map((r) => r.talla))].sort((a, b) => a.localeCompare(b));
                const cant = (c, t) =>
                  desgloceRows
                    .filter((r) => r.color === c && r.talla === t)
                    .reduce((sum, r) => sum + r.cantidad, 0);
                const totalGeneral = desgloceRows.reduce((sum, r) => sum + r.cantidad, 0);
                return (
                  <div style={{ width: "100%", overflowX: "auto" }}>
                    <Table size="sm" striped bordered style={{ minWidth: `${(tallas.length + 2) * 90}px`, whiteSpace: "nowrap", marginBottom: 0 }}>
                      <thead>
                        <tr>
                          <th style={{ position: "sticky", left: 0, backgroundColor: "#fff", zIndex: 2, minWidth: "150px" }}>Color</th>
                          {tallas.map((t) => (
                            <th key={t} style={{ minWidth: "90px", textAlign: "center" }}>{t}</th>
                          ))}
                          <th style={{ minWidth: "100px", textAlign: "center" }}>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {colores.map((c) => {
                          const totalFila = tallas.reduce((sum, t) => sum + cant(c, t), 0);
                          return (
                            <tr key={c}>
                              <td style={{ position: "sticky", left: 0, backgroundColor: "#fff", zIndex: 1, fontWeight: 600 }}>{c}</td>
                              {tallas.map((t) => {
                                const q = cant(c, t);
                                return (
                                  <td key={t} style={{ textAlign: "center", color: q ? "inherit" : "#cbd5e1" }}>
                                    {q ? new Intl.NumberFormat("en-US").format(q) : "-"}
                                  </td>
                                );
                              })}
                              <td style={{ textAlign: "center", fontWeight: 700 }}>
                                {new Intl.NumberFormat("en-US").format(totalFila)}
                              </td>
                            </tr>
                          );
                        })}
                        <tr>
                          <td style={{ position: "sticky", left: 0, backgroundColor: "#fff", zIndex: 1, fontWeight: 700 }}>Total</td>
                          {tallas.map((t) => {
                            const totalCol = colores.reduce((sum, c) => sum + cant(c, t), 0);
                            return (
                              <td key={t} style={{ textAlign: "center", fontWeight: 700 }}>
                                {new Intl.NumberFormat("en-US").format(totalCol)}
                              </td>
                            );
                          })}
                          <td style={{ textAlign: "center", fontWeight: 700 }}>
                            {new Intl.NumberFormat("en-US").format(totalGeneral)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                );
              })()
            )}
          </ModalBody>
        </Modal>
     
      {loader}
    </>
  );
}

export default ListadoInventarios;
